import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ArticlesSearch} from '../entities/ArticlesSearch';
import {map} from 'rxjs/operators';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';

@Injectable()
export class ArticleService {

  private base_url: String = environment.resource_api;

  constructor(private http: HttpClient, private localStorageService: LocalStorageService ) { }

  public getArticles(data: ArticlesSearch) {
    return this.http.post(this.base_url + 'articles/search', data,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})}).pipe(
        map((res: {message: string, data: any}) => res.data)
    );
  }

  public getArticlesFromCsv(values: {articleNumbers: string[], companyId: number, newPrice?: boolean | false}) {
    return this.http.post(this.base_url + 'articles/', values,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})}).pipe(
      map((res: {message: string, data: any}) => res.data)
    );
  }

  public orderArticles(data: any) {
    return this.http.post(this.base_url + 'orders/order', data,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }

  public Orders(skip: number, take: number, search?: string) {
    return this.http.get(`${this.base_url}orders/?skip=${(skip * take)}&take=${take}` + (search ? `&search=${search}` : ''), {
      headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})
    }).pipe(map((res: {message: string, data: any}) => res.data));
  }

  public getById(id: any) {
    return this.http.get(this.base_url + 'orders/' + id, {
      headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})
    });
  }

  public setCard(items: any[], reference: string, car: number, brand: number) {
    return this.http.post(`${this.base_url}carts/`, {items, reference, car, brand} ,  {
      headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})
    });
  }

  public getCards(skip: number, take: number, search?: string) {
    return this.http.get(`${this.base_url}carts/?skip=${(skip * take)}&take=${take}` + (search ? `&search=${search}` : ''), {
      headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})
    }).pipe(map((res: {message: string, data: any}) => res.data));
  }

  public deleteCard(id: number) {
    return this.http.post(`${this.base_url}carts/${id}`, {} , {
      headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')}),
    });
  }
}
